export { default } from './YouTubePlayer';



// WEBPACK FOOTER //
// ./src/components/atoms/YouTubePlayer/index.js